<template>
  <v-text-field v-model="editorValue" ref="dateEditorField" :dense="dense" :hide-details="hideDetails" :disabled="disabled" :label="label" :outlined="outlined" :clearable="!required" append-icon="mdi-calendar-text-outline" @input="()=>{}" @click:append="visible=true" @blur="onBlur" @click:clear="onClear">
    <template v-slot:prepend-inner>
      <v-menu :activator="$refs.dateEditorField" :open-on-click="false" v-model="visible" transition="scale-transition" :close-on-content-click="false" max-width="290">
        <v-date-picker v-model="pickerValue" locale="zh" @input="onPicked" :day-format="(e)=>parseInt(new Date(e).getDate())"></v-date-picker>
      </v-menu>
    </template>
  </v-text-field>

</template>
<script>
import EditorProps from '../EditorProps';
export default {
  name: 'date-editor',
  props: { ...EditorProps.custom, ...EditorProps.vuetify },
  data () {
    return {
      visible: false,
      editorValue: null,
      pickerValue: null,
      oldValue: null
      // editorValue: this.value,
      // pickerValue: this.value,
      // oldValue: this.value
    }
  },
  watch: {
    value (v1) {
      this.editorValue = v1;
      this.pickerValue = v1;
      this.oldValue = v1;
    }
  },
  methods: {
    onBlur () {
      let v = this.Utility.fmtDt2(this.editorValue);
      this.editorValue = v ? this.Utility.parseDt(v) : null;
      this.pickerValue = this.editorValue;
      this.triggerChange();
    },
    onPicked () {
      this.visible = false;
      this.editorValue = this.pickerValue;
      this.triggerChange();
    },
    onClear () {
      this.pickerValue = this.editorValue;
      this.triggerChange();
    },
    triggerChange () {
      this.$emit('input', this.editorValue);
      this.$emit('change', this.oldValue, this.editorValue);
      this.oldValue = this.editorValue;
    }
  }
}
</script>